export default "__VITE_ASSET__40904f4b__"